import React, { useState, FC } from 'react'
import { Trans, t } from '@lingui/macro'
import { find } from 'lodash'
import { Box, Flex } from '@chakra-ui/react'
import { Redirect } from 'react-router-dom'

import { NewTemplateModal } from './NewTemplateModal'
import { ButtonPrimary } from 'front-end/src/components'
import Select from '../../../components/common/select/Select'
import Label from '../../../components/common/form/label/Label'
import IconPlus2 from '../../../components/common/icon/IconPlus2'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import { useCertificateTemplatesQuery } from './CertificateTemplatesPage.codegen'

interface IProps {
  header?: string
  templateId?: number | null
  onSelect: (value: number) => void
  allowCreateNew?: boolean
  onNewCreated?: () => unknown
}

export const CertificateTemplatePageHeader: FC<IProps> = ({
  templateId,
  header,
  onSelect,
  onNewCreated,
  allowCreateNew
}) => {
  const [showModal, setShowModal] = useState(false)

  const { data } = useCertificateTemplatesQuery()

  const certificateTemplates = data?.admin?.organisation?.certificateTemplates

  const options =
    certificateTemplates
      ?.filter((c) => !c.deleted_at || c.id === templateId)
      .map((t) => ({
        label: t.name,
        value: t.id
      })) || []

  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
      marginRight: '16px'
    })
  }

  const defaultTemplate = certificateTemplates?.find((o) => o.default)

  if (!templateId && defaultTemplate) {
    return (
      <Redirect to={linkBuilder.certificationsTemplates(defaultTemplate.id)} />
    )
  }

  return (
    <Flex m="24px 0 24px" p="16px 0 0" justifyContent="center">
      <Box flexGrow={1}>
        <Label
          htmlFor="CertificateTemplate__topbar__select"
          title={header ? header : t`Certification templates`}
        />
        <div className="CertificateTemplate__topbar">
          <Select
            id="CertificateTemplate__topbar__select"
            styles={styles}
            value={find(options, (option) => option.value === templateId)}
            options={options}
            onChange={(value) => value && onSelect(value.value)}
          />
        </div>
      </Box>

      {allowCreateNew && (
        <Box alignSelf={'flex-end'}>
          <ButtonPrimary
            onClick={() => setShowModal(true)}
            leftIcon={<IconPlus2 />}
          >
            <Trans>New template</Trans>
          </ButtonPrimary>
          <NewTemplateModal
            show={showModal}
            onHide={() => setShowModal(false)}
            onSubmit={() => {
              setShowModal(false)
              onNewCreated?.()
            }}
          />
        </Box>
      )}
    </Flex>
  )
}
